import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { MgIconModule } from '@app/src/app/icon';
import { PermissionsModule } from '@app/src/app/permissions';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { MembershipListTableModule } from '@shared/components/membership-list-table';
import { SettingsModule } from '@shared/components/settings/settings.module';
import { TextModule } from '@shared/components/text';
import { LoadingPipesModule } from '@shared/pipes';

import { CheckinManagerSettingsComponent } from './checkin-manager-settings.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgIconModule,
    SettingsModule,
    MgSpinnerModule,
    LoadingPipesModule,
    ManagerOverlayModule,
    PermissionsModule,
    TextModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    FormsModule,
    MembershipListTableModule,
  ],
  declarations: [CheckinManagerSettingsComponent],
  exports: [CheckinManagerSettingsComponent],
})
export class CheckinManagerSettingsModule {}
